export const getFileExtension = (path: string) => {
  return path.split(".").pop();
};
